<div class="text-center fixed-bottom text-white pb-0 mb-0 copyright">
    <img src="../../assets/images/copyright.png" height="12">
    Copyright 2021
    <b>SIGELAM</b>
    All rights reserved
</div>
